/**
 * @Email : aullah@ibl.mx
 * @Author: abaid
 * @JobTitle: Full Stack Developer
 *
 * Custom hook `InvitationDetailsApp` for managing invitation creation process.
 * Handles visitor search, type selection, date range, zone assignment, and dynamic form fields.
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    GetInvitationById,
} from '../../../../../reduxToolkit/Invitation/InvitationApi';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const InvitationDetailsApp = () => {
    const { t } = useTranslation();
    // State hooks for managing form data and UI state
    const dispatch = useDispatch();
    const { id } = useParams();
    const { getInvitationById } = useSelector((state) => state?.InvitationSlice);

    useEffect(() => {
        if (id) {
            dispatch(GetInvitationById(id));
        }
    }, [id]);

    // Return all state and handlers for consumption by component
    return {
        t,
        getInvitationById
    };
};

export default InvitationDetailsApp;
